import { render } from "./OnboardingCodeInput.vue?vue&type=template&id=5091545c&scoped=true"
import script from "./OnboardingCodeInput.vue?vue&type=script&lang=js"
export * from "./OnboardingCodeInput.vue?vue&type=script&lang=js"

import "./OnboardingCodeInput.vue?vue&type=style&index=0&id=5091545c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5091545c"]])

export default __exports__